module.exports = __webpack_public_path__ + "img/female-inactive.d85b8f36.svg";